import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { baseUrls } from '../../appConstant';
@Component({
  selector: 'app-card-for-class-program',
  templateUrl: './card-for-class-program.component.html',
  styleUrls: ['./card-for-class-program.component.scss']
})
export class CardForClassProgramComponent implements OnInit {

  imageUrl = baseUrls.images;
  hostedUrl = baseUrls.hostedUrl;
  constructor(private location: Location) { }
  ngOnInit(): void {
    // console.log('ngOnInit_classOrProgram', this.classOrProgramInfo);
  }

  @Input('classOrProgramInfo')classOrProgramInfo;

  classOrProgramRoute(classOrProgramInfoPassed){
    // console.log('classOrProgramRoute', classOrProgramInfoPassed);
    let locationToRoute = classOrProgramInfoPassed?.product == "program" ? 'true' : 'false'; // true means programs 
    if(locationToRoute == 'false'){
      // window.location.href = this.hostedUrl+'livewell/class/'+classOrProgramInfoPassed?.slug
      window.open(this.hostedUrl+'livewell/class/'+classOrProgramInfoPassed?.slug, '_blank');
      // this.location.prepareExternalUrl(this.baseUrl+'livewell/class/:'+classOrProgramInfoPassed?.slug);
    }
    if(locationToRoute == 'true'){
      // window.location.href = this.hostedUrl+'livewell/program/'+classOrProgramInfoPassed?.slug;
      window.open(this.hostedUrl+'livewell/program/'+classOrProgramInfoPassed?.slug, '_blank');
      // this.location.prepareExternalUrl(this.baseUrl+'livewell/program/:'+classOrProgramInfoPassed?.slug);
    }
  }

  goToInstructorPage(eventPassed, slugOfInstructor){
    // console.log('goToInstructorPage', eventPassed, slugOfInstructor);
    if(slugOfInstructor){
      // window.location.href = this.hostedUrl+'livewell/instructor/'+slugOfInstructor;
      window.open(this.hostedUrl+'livewell/instructor/'+slugOfInstructor);
    }
    eventPassed?.stopPropagation();
  }
}
